import { getHttpClient } from '@/shared/api/http-client.js';
import type { RequestOptions } from '@/shared/api/types.js';

const PLATFORM_API_PREFIX = '/api/platform/v1';

function withPlatformDefaults(options?: RequestOptions): RequestOptions {
  return {
    ...options,
    skipPlace: true,
  };
}

function platformPath(path: string): string {
  return path.startsWith('/') ? `${PLATFORM_API_PREFIX}${path}` : `${PLATFORM_API_PREFIX}/${path}`;
}

/** HTTP client for `/api/platform/v1` — never sends place header. */
export const platformHttp = {
  get<T>(path: string, options?: RequestOptions): Promise<T> {
    return getHttpClient().get<T>(platformPath(path), withPlatformDefaults(options));
  },
  post<T>(path: string, body?: unknown, options?: RequestOptions): Promise<T> {
    return getHttpClient().post<T>(platformPath(path), body, withPlatformDefaults(options));
  },
  patch<T>(path: string, body?: unknown, options?: RequestOptions): Promise<T> {
    return getHttpClient().patch<T>(platformPath(path), body, withPlatformDefaults(options));
  },
  put<T>(path: string, body?: unknown, options?: RequestOptions): Promise<T> {
    return getHttpClient().put<T>(platformPath(path), body, withPlatformDefaults(options));
  },
  delete<T>(path: string, body?: unknown, options?: RequestOptions): Promise<T> {
    return getHttpClient().delete<T>(platformPath(path), body, withPlatformDefaults(options));
  },
};
